import { Maybe } from '@web/gql/graphql'

const checkIterateeAndAddOnResult = <T>(
  arr = [] as T[] | Maybe<T>[] | Maybe<Maybe<T>>,
  iteratee: keyof T,
  set: Set<T[keyof T]>,
  result: T[],
) => {
  if (Array.isArray(arr))
    arr.forEach(item => {
      if (item && !set.has(item[iteratee])) {
        set.add(item[iteratee])
        result.push(item)
      }
    })
}

const unionBy = <T>(
  arr1 = [] as T[] | Maybe<T>[] | Maybe<Maybe<T>>,
  arr2 = [] as T[] | Maybe<T>[] | Maybe<Maybe<T>>,
  iteratee: keyof T,
) => {
  const iteratees = new Set<T[keyof T]>()
  const result: T[] = []

  checkIterateeAndAddOnResult(arr1, iteratee, iteratees, result)
  checkIterateeAndAddOnResult(arr2, iteratee, iteratees, result)

  return result
}

export default unionBy
